// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2326":"2f462bed917b6d34","7026":"f40790cde27b0ab7","7888":"62673d9a00ca1f27","8117":"595a2cb19599af57"}[chunkId] + ".js";
};